import * as React from 'react';
import { useFormikContext } from 'formik';
import Workflow from '../../../models/be/Workflow';
import ErrorMessage from '../../../commonComponents/ErrorMessage';
import { hiddenErrorKey } from './form';

const AdditionalNameDatesValidator = (props: Props) => {
	const { errors, setFieldError } = useFormikContext<{ [hiddenErrorKey]: string }>();

	if (!props.visibleWorkflowFields?.customFields?.hasOtherNames) return <></>;

	const isValid = additionalNameDatesAreOnOrAfterBirthDate(props.visibleWorkflowFields);

	const errorMessage = 'AdditionalNameDatesValidatorError';
	if (!isValid && errors[hiddenErrorKey] !== errorMessage) {
		// Set the field after formik has finished rendering to avoid a React warning.
		setTimeout(() => {
			setFieldError(hiddenErrorKey, errorMessage);
		}, 0);
	}

	return (
		<>
			{errors[hiddenErrorKey] && (
				<ErrorMessage message={<p>Additional Name dates need to come after your date of birth.</p>} />
			)}
		</>
	);
};

export default AdditionalNameDatesValidator;

interface Props {
	visibleWorkflowFields: Workflow;
}

const additionalNameDatesAreOnOrAfterBirthDate = (workflow: Workflow) => {
	const birthDateValue = workflow.birthDetails?.birthDate;
	if (!birthDateValue) return true;
	const birthDate = new Date(birthDateValue);
	return workflow.additionalNames?.every((an) => an.type === 'Maiden' || birthDate <= new Date(an.fromDate));
};
